import React from "react";

export function RoleSwitchButton({ show, label, onClick, variant = "default" }) {
  if (!show) return null;

  const baseClasses = "lumen-glow-button";

  return (
    <button
      onClick={onClick}
      className={baseClasses}
    >
      {/* Je gebruikte eerder FaExchangeAlt; om dependency-verschillen te vermijden laten we icon optioneel */}
      {label}
    </button>
  );
}
